import { Component, inject } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { finalize } from "rxjs/operators";
import { FormControlBase } from "src/app/common-components/form-controls/form-control-base";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";
import { v4 as uuidv4 } from 'uuid';
import {
  NoteFacilityCreateCommand,
  NotesClientProvider,
  NotesFacilitySyncCommand,
  ValidationResult,
} from "src/app/web-api/web-api";
import { WawiApiNoteFacilityCreateFormGroup } from "./form/note-facility-create-form.component";

export interface IWawiApiNoteFacilityCreateDialogData {
  facilityNoInternal: string;
}

@Component({
    templateUrl: "./note-facility-create-dialog.component.html",
    styleUrls: ["./note-facility-create-dialog.component.scss"],
    standalone: false
})
export class WawiApiNoteFacilityCreateDialogComponent extends CstResponsivePopupComponentBase<IWawiApiNoteFacilityCreateDialogData> {
  private _client = inject(NotesClientProvider);

  public loading = false;
  public form: WawiApiNoteFacilityCreateFormGroup;

  public constructor() {
    const fb = inject(FormBuilder);

    super();
    this.form = new WawiApiNoteFacilityCreateFormGroup(fb);
  }

  onInitialised() {
    if (this.data.facilityNoInternal) {
      this.form.facilityNoInternal.setValue(this.data.facilityNoInternal);
      this.form.facilityNoInternal.disable();
    }
  }

  public OnAccept() {
    if (!this.form.valid) {
      return;
    }
    const key = uuidv4();
    const createCmd = new NoteFacilityCreateCommand();
    createCmd.init({ ...this.form.getRawValue(), offlineID: key });
    const syncCmd = new NotesFacilitySyncCommand();
    syncCmd.init({ createCommands: [createCmd] });
    this.loading = true;
    this._client
      .notesFacilitySync(syncCmd)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (result) => {
          this.close(result.created[key]);
        },
        error: (error) => {
          if (error instanceof ValidationResult) {
            for (const prop of error.properties) {
              prop.property = prop.property.replace(
                /createcommands\[[0-9]\]\./gim,
                ""
              );
            }
            setTimeout(
              () =>
                FormControlBase.ApplyValidationResultToForm(this.form, error),
              200
            );
            return;
          }
        },
      });
  }

  public OnCancel() {
    this.close(null);
  }
}
